/**
 * Official Raheasy Facebook page (footer, social feed strip, fallback cards).
 * @type {string}
 */
export const FACEBOOK_PAGE_URL = 'https://web.facebook.com/Raheasyapp/?_rdc=1&_rdr#';
